import { Button } from "@/components/ui/button/button";

import { useComputeTargetDate } from "./hooks";
import { type PresetOptionsType, PRESET_OPTIONS_MAP } from "./type";
import { useCalender } from "../../../context/calendar/calendar-context";
import { isDayPickerRange } from "../../../types/calendar-range";

const PRESET_OPTIONS = [
	{
		label: "今日",
		value: PRESET_OPTIONS_MAP.TODAY,
	},
	{
		label: "過去7日間",
		value: PRESET_OPTIONS_MAP.LAST_7_DAYS,
	},
	{
		label: "今後7日間",
		value: PRESET_OPTIONS_MAP.NEXT_7_DAYS,
	},
	{
		label: "先月",
		value: PRESET_OPTIONS_MAP.LAST_MONTH,
	},
	{
		label: "今月",
		value: PRESET_OPTIONS_MAP.THIS_MONTH,
	},
	{
		label: "来月",
		value: PRESET_OPTIONS_MAP.NEXT_MONTH,
	},
];

export const PresetOptions = () => {
	const calendar = useCalender();
	const { showPresetOptions } = calendar;

	const filteredPresetOptions = (() => {
		switch (showPresetOptions) {
			case "exclude-past-options": {
				return PRESET_OPTIONS.filter(
					(option) =>
						option.value === PRESET_OPTIONS_MAP.TODAY ||
						option.value === PRESET_OPTIONS_MAP.THIS_MONTH ||
						option.value === PRESET_OPTIONS_MAP.NEXT_7_DAYS ||
						option.value === PRESET_OPTIONS_MAP.NEXT_MONTH,
				);
			}
			case "exclude-future-options": {
				return PRESET_OPTIONS.filter(
					(option) =>
						option.value === PRESET_OPTIONS_MAP.TODAY ||
						option.value === PRESET_OPTIONS_MAP.THIS_MONTH ||
						option.value === PRESET_OPTIONS_MAP.LAST_7_DAYS ||
						option.value === PRESET_OPTIONS_MAP.LAST_MONTH,
				);
			}
			case "all-options": {
				return PRESET_OPTIONS;
			}
			case "not-show-preset-options":
			default:
				return [];
		}
	})();

	const { computeTargetDateForRange } = useComputeTargetDate();

	const selectDate = (value: PresetOptionsType) => {
		if (isDayPickerRange(calendar)) {
			const { from, to } = computeTargetDateForRange(value);

			calendar.onSelect({
				from,
				to,
			});
		}
	};

	const handleClick = (value: PresetOptionsType) => (_event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		selectDate(value);
	};

	return (
		<div className="flex max-w-[340px] flex-wrap gap-2 tablet:max-w-fit">
			{filteredPresetOptions.map((option) => (
				<Button
					className="w-fit"
					key={option.value}
					variant="input-ish"
					size="sm"
					onClick={handleClick(option.value)}
				>
					{option.label}
				</Button>
			))}
		</div>
	);
};
